export const ContractTypeReducer = (
    state = {
        records: [
            { typeId: 0, description: "Lump Sum" },
            { typeId: 1, description: "Upper Limiting Fee" },
            { typeId: 2, description: "Time & Expenses" },
            { typeId: 3, description: "Client Support Role" },
            { typeId: 4, description: "No Invoices Required" }
        ]
    }) => { return state }